/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PrivacyAndTermsSplatRouteImport } from './routes/privacy-and-terms.$'
import { Route as AuthSignUpRouteImport } from './routes/_auth.sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth.sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthCreateProfileRouteImport } from './routes/_auth.create-profile'
import { Route as AuthConfirmEmailRouteImport } from './routes/_auth.confirm-email'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppListRouteImport } from './routes/_app._list'
import { Route as AppListIndexRouteImport } from './routes/_app._list.index'
import { Route as AppArticlesIdRouteImport } from './routes/_app.articles.$id'
import { Route as AppListSavedRouteImport } from './routes/_app._list.saved'
import { Route as AppListHistoryRouteImport } from './routes/_app._list.history'
import { Route as AppListSearchTabRouteImport } from './routes/_app._list.search.$tab'
import { Route as AppListPublishersIdRouteImport } from './routes/_app._list.publishers.$id'
import { Route as AuthApiV1AuthGoogleCallbackRouteImport } from './routes/_auth.api.v1.auth.google.callback'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyAndTermsSplatRoute = PrivacyAndTermsSplatRouteImport.update({
  id: '/privacy-and-terms/$',
  path: '/privacy-and-terms/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreateProfileRoute = AuthCreateProfileRouteImport.update({
  id: '/create-profile',
  path: '/create-profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConfirmEmailRoute = AuthConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppListRoute = AppListRouteImport.update({
  id: '/_list',
  getParentRoute: () => AppRoute,
} as any)
const AppListIndexRoute = AppListIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppListRoute,
} as any)
const AppArticlesIdRoute = AppArticlesIdRouteImport.update({
  id: '/articles/$id',
  path: '/articles/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppListSavedRoute = AppListSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AppListRoute,
} as any)
const AppListHistoryRoute = AppListHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppListRoute,
} as any)
const AppListSearchTabRoute = AppListSearchTabRouteImport.update({
  id: '/search/$tab',
  path: '/search/$tab',
  getParentRoute: () => AppListRoute,
} as any)
const AppListPublishersIdRoute = AppListPublishersIdRouteImport.update({
  id: '/publishers/$id',
  path: '/publishers/$id',
  getParentRoute: () => AppListRoute,
} as any)
const AuthApiV1AuthGoogleCallbackRoute =
  AuthApiV1AuthGoogleCallbackRouteImport.update({
    id: '/api/v1/auth/google/callback',
    path: '/api/v1/auth/google/callback',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/settings': typeof AppSettingsRoute
  '/confirm-email': typeof AuthConfirmEmailRoute
  '/create-profile': typeof AuthCreateProfileRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/privacy-and-terms/$': typeof PrivacyAndTermsSplatRoute
  '/history': typeof AppListHistoryRoute
  '/saved': typeof AppListSavedRoute
  '/articles/$id': typeof AppArticlesIdRoute
  '/': typeof AppListIndexRoute
  '/publishers/$id': typeof AppListPublishersIdRoute
  '/search/$tab': typeof AppListSearchTabRoute
  '/api/v1/auth/google/callback': typeof AuthApiV1AuthGoogleCallbackRoute
}
export interface FileRoutesByTo {
  '/settings': typeof AppSettingsRoute
  '/confirm-email': typeof AuthConfirmEmailRoute
  '/create-profile': typeof AuthCreateProfileRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/privacy-and-terms/$': typeof PrivacyAndTermsSplatRoute
  '/history': typeof AppListHistoryRoute
  '/saved': typeof AppListSavedRoute
  '/articles/$id': typeof AppArticlesIdRoute
  '/': typeof AppListIndexRoute
  '/publishers/$id': typeof AppListPublishersIdRoute
  '/search/$tab': typeof AppListSearchTabRoute
  '/api/v1/auth/google/callback': typeof AuthApiV1AuthGoogleCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/_list': typeof AppListRouteWithChildren
  '/_app/settings': typeof AppSettingsRoute
  '/_auth/confirm-email': typeof AuthConfirmEmailRoute
  '/_auth/create-profile': typeof AuthCreateProfileRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/privacy-and-terms/$': typeof PrivacyAndTermsSplatRoute
  '/_app/_list/history': typeof AppListHistoryRoute
  '/_app/_list/saved': typeof AppListSavedRoute
  '/_app/articles/$id': typeof AppArticlesIdRoute
  '/_app/_list/': typeof AppListIndexRoute
  '/_app/_list/publishers/$id': typeof AppListPublishersIdRoute
  '/_app/_list/search/$tab': typeof AppListSearchTabRoute
  '/_auth/api/v1/auth/google/callback': typeof AuthApiV1AuthGoogleCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/settings'
    | '/confirm-email'
    | '/create-profile'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/privacy-and-terms/$'
    | '/history'
    | '/saved'
    | '/articles/$id'
    | '/'
    | '/publishers/$id'
    | '/search/$tab'
    | '/api/v1/auth/google/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/settings'
    | '/confirm-email'
    | '/create-profile'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/privacy-and-terms/$'
    | '/history'
    | '/saved'
    | '/articles/$id'
    | '/'
    | '/publishers/$id'
    | '/search/$tab'
    | '/api/v1/auth/google/callback'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/_list'
    | '/_app/settings'
    | '/_auth/confirm-email'
    | '/_auth/create-profile'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/privacy-and-terms/$'
    | '/_app/_list/history'
    | '/_app/_list/saved'
    | '/_app/articles/$id'
    | '/_app/_list/'
    | '/_app/_list/publishers/$id'
    | '/_app/_list/search/$tab'
    | '/_auth/api/v1/auth/google/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PrivacyAndTermsSplatRoute: typeof PrivacyAndTermsSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-and-terms/$': {
      id: '/privacy-and-terms/$'
      path: '/privacy-and-terms/$'
      fullPath: '/privacy-and-terms/$'
      preLoaderRoute: typeof PrivacyAndTermsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/create-profile': {
      id: '/_auth/create-profile'
      path: '/create-profile'
      fullPath: '/create-profile'
      preLoaderRoute: typeof AuthCreateProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/confirm-email': {
      id: '/_auth/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof AuthConfirmEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_list': {
      id: '/_app/_list'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppListRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_list/': {
      id: '/_app/_list/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppListIndexRouteImport
      parentRoute: typeof AppListRoute
    }
    '/_app/articles/$id': {
      id: '/_app/articles/$id'
      path: '/articles/$id'
      fullPath: '/articles/$id'
      preLoaderRoute: typeof AppArticlesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_list/saved': {
      id: '/_app/_list/saved'
      path: '/saved'
      fullPath: '/saved'
      preLoaderRoute: typeof AppListSavedRouteImport
      parentRoute: typeof AppListRoute
    }
    '/_app/_list/history': {
      id: '/_app/_list/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppListHistoryRouteImport
      parentRoute: typeof AppListRoute
    }
    '/_app/_list/search/$tab': {
      id: '/_app/_list/search/$tab'
      path: '/search/$tab'
      fullPath: '/search/$tab'
      preLoaderRoute: typeof AppListSearchTabRouteImport
      parentRoute: typeof AppListRoute
    }
    '/_app/_list/publishers/$id': {
      id: '/_app/_list/publishers/$id'
      path: '/publishers/$id'
      fullPath: '/publishers/$id'
      preLoaderRoute: typeof AppListPublishersIdRouteImport
      parentRoute: typeof AppListRoute
    }
    '/_auth/api/v1/auth/google/callback': {
      id: '/_auth/api/v1/auth/google/callback'
      path: '/api/v1/auth/google/callback'
      fullPath: '/api/v1/auth/google/callback'
      preLoaderRoute: typeof AuthApiV1AuthGoogleCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AppListRouteChildren {
  AppListHistoryRoute: typeof AppListHistoryRoute
  AppListSavedRoute: typeof AppListSavedRoute
  AppListIndexRoute: typeof AppListIndexRoute
  AppListPublishersIdRoute: typeof AppListPublishersIdRoute
  AppListSearchTabRoute: typeof AppListSearchTabRoute
}

const AppListRouteChildren: AppListRouteChildren = {
  AppListHistoryRoute: AppListHistoryRoute,
  AppListSavedRoute: AppListSavedRoute,
  AppListIndexRoute: AppListIndexRoute,
  AppListPublishersIdRoute: AppListPublishersIdRoute,
  AppListSearchTabRoute: AppListSearchTabRoute,
}

const AppListRouteWithChildren =
  AppListRoute._addFileChildren(AppListRouteChildren)

interface AppRouteChildren {
  AppListRoute: typeof AppListRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRoute
  AppArticlesIdRoute: typeof AppArticlesIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppListRoute: AppListRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppArticlesIdRoute: AppArticlesIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthConfirmEmailRoute: typeof AuthConfirmEmailRoute
  AuthCreateProfileRoute: typeof AuthCreateProfileRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthApiV1AuthGoogleCallbackRoute: typeof AuthApiV1AuthGoogleCallbackRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthConfirmEmailRoute: AuthConfirmEmailRoute,
  AuthCreateProfileRoute: AuthCreateProfileRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthApiV1AuthGoogleCallbackRoute: AuthApiV1AuthGoogleCallbackRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PrivacyAndTermsSplatRoute: PrivacyAndTermsSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
